import React from "react";
import { Grid, Box, Typography } from "@mui/material";

const Footer = ({ t, onClickGoToPage, whiteHeart, topArrow }) => {
  
  // Helper to handle the heavy scrolling logic you have for mobile/desktop
  const handleNavigation = (pageName) => {
    // Initial scroll
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // Trigger navigation
    const eventHandler = onClickGoToPage(pageName);
    eventHandler();

    // The "multiple attempts" scroll logic from your original code
    [50, 100, 300, 1000].forEach((delay) => {
      setTimeout(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, delay);
    });
  };

  return (
    <Grid sx={{ backgroundColor: "black", padding: "1.5rem", marginTop: "auto" }}>
      
      {/* DESKTOP FOOTER (Visible on md and up) */}
      <Box sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
        <Grid container>
          <Grid item xs={12} md={3} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <img alt="whiteHeart" src={whiteHeart} style={{ width: "66px", height: "auto" }} />
          </Grid>
          
          <Grid item xs={12} md={3} sx={{ textAlign: "left" }}>
            <Typography sx={footerLinkStyle} onClick={() => handleNavigation("Landing")}>{t('nav.home')}</Typography>
            <Typography sx={footerLinkStyle} onClick={() => handleNavigation("About")}>{t('nav.team')}</Typography>
            <Typography sx={footerLinkStyle} onClick={() => handleNavigation("FAQ")}>{t('nav.faq')}</Typography>
            <Typography sx={footerLinkStyle} onClick={() => handleNavigation("Publications")}>{t('pubs.publications')}</Typography>
          </Grid>

          <Grid item xs={12} md={3} sx={{ textAlign: "left", display: "Grid" }}>
            <Box sx={{ paddingTop: "15px" }}>
              <Typography sx={{ color: "#D4D5D9", fontSize: "10px", fontWeight: 500 }}>{t('footer.contact_us')}</Typography>
              <Typography sx={{ color: "#D4D5D9", fontSize: "20px", fontWeight: "500" }}>+1 (212) 824-7786</Typography>
            </Box>
            <Box sx={{ display: "Grid", alignItems: "end", paddingTop: "15px" }}>
              <Typography sx={{ color: "#D4D5D9", fontSize: "10px", fontWeight: "500" }}>{t('landing.footer_email')}</Typography>
              <Typography sx={{ color: "#D4D5D9", fontSize: "20px", fontWeight: "500" }}>wisdom@mssm.edu</Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={3} sx={{ textAlign: "left", display: "Grid", justifyContent: "end" }}>
            <img 
              alt="Back to Top of Page" 
              src={topArrow} 
              style={{ width: "40px", height: "auto", cursor: "pointer" }} 
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} 
            />
          </Grid>
        </Grid>
      </Box>

      {/* MOBILE FOOTER (Visible on xs and sm) */}
      <Box sx={{ display: { xs: "block", sm: "block", md: "none" } }}>
        <Grid container sx={{ alignItems: "center" }}>
          <Grid item xs={3} sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
            <img alt="whiteHeart" src={whiteHeart} style={{ width: "50px", height: "auto" }} />
          </Grid>

          <Grid item xs={4} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Typography sx={mobileLinkStyle} onClick={() => handleNavigation("Landing")}>{t('nav.home')}</Typography>
            <Typography sx={mobileLinkStyle} onClick={() => handleNavigation("About")}>{t('nav.team')}</Typography>
            <Typography sx={mobileLinkStyle} onClick={() => handleNavigation("FAQ")}>{t('nav.faq')}</Typography>
            <Typography sx={mobileLinkStyle} onClick={() => handleNavigation("Publications")}>{t('nav.publications')}</Typography>
          </Grid>

          <Grid item xs={3} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Typography sx={{ color: "#D4D5D9", fontSize: "0.75rem", fontWeight: 500, marginBottom: "4px" }}>{t('landing.footer_contact')}</Typography>
            <Typography sx={{ color: "#D4D5D9", fontSize: "0.75rem", fontWeight: "500", marginBottom: "10px" }}>+1 (212) 824-7786</Typography>
            <Typography sx={{ color: "#D4D5D9", fontSize: "0.75rem", fontWeight: "500", marginBottom: "0.5rem" }}>{t('landing.footer_email')}</Typography>
            <Typography sx={{ color: "#D4D5D9", fontSize: "0.75rem", fontWeight: "500" }}>wisdom@mssm.edu</Typography>
          </Grid>

          <Grid item xs={2} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
            <img 
              alt="UpArrow" 
              src={topArrow} 
              style={{ width: "35px", height: "auto", cursor: "pointer" }} 
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} 
            />
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
};

// Styles to keep the JSX clean
const footerLinkStyle = {
  color: "#D4D5D9",
  fontSize: "16px",
  fontWeight: 400,
  marginBottom: "15px",
  cursor: "pointer",
};

const mobileLinkStyle = {
  color: "#D4D5D9",
  fontSize: "14px",
  fontWeight: 400,
  marginBottom: "8px",
  cursor: "pointer",
};

export default Footer;